export const ISSUE_VIEW = 'ISSUE_VIEW';
export const CLASSIC_BOARD = 'CLASSIC_BOARD';
export const COMPANY_MANAGED_BOARD = 'COMPANY_MANAGED_BOARD';
export const TEAM_MANAGED_BOARD = 'TEAM_MANAGED_BOARD';
export const CLASSIC_BACKLOG = 'CLASSIC_BACKLOG';
export const COMPANY_MANAGED_BACKLOG = 'COMPANY_MANAGED_BACKLOG';
export const TEAM_MANAGED_BACKLOG = 'TEAM_MANAGED_BACKLOG';
export const GIN_GLOBAL_ISSUE_NAVIGATOR = 'GIN_GLOBAL_ISSUE_NAVIGATOR';
export const NIN_NEW_ISSUE_NAVIGATOR = 'NIN_NEW_ISSUE_NAVIGATOR';
export const DASHBOARD = 'DASHBOARD';
export const ISSUE_MOVE = 'ISSUE_MOVE';
export const GLOBAL_ISSUE_CREATE = 'GLOBAL_ISSUE_CREATE';

export const CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
